import { useState, useCallback } from "react";
import { Input } from "@/components/ui/input";
import { formatIndianNumber, stripCommas } from "@/utils/formatIndian";

/**
 * Input component that formats numbers with Indian comma style (lakhs, crores).
 * Shows formatted value while focused/blurred, stores raw numeric value.
 */
export const IndianNumberInput = ({ value, name, onChange, className = "", ...props }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [localValue, setLocalValue] = useState('');

  const rawValue = value !== undefined && value !== null ? String(value) : '';

  const handleFocus = useCallback(() => {
    setIsFocused(true);
    setLocalValue(rawValue);
  }, [rawValue]);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const handleChange = useCallback((e) => {
    const input = e.target.value;
    // Allow digits, decimal point, minus sign only
    const cleaned = input.replace(/[^0-9.\-]/g, '');
    setLocalValue(cleaned);
    // Fire onChange with cleaned numeric value
    onChange({ target: { name, value: cleaned } });
  }, [name, onChange]);

  const displayValue = isFocused ? localValue : formatIndianNumber(rawValue);

  return (
    <Input
      {...props}
      name={name}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={className}
      inputMode="decimal"
    />
  );
};

export default IndianNumberInput;
